import { ref } from 'vue'
import { api } from '@/helpers/api'
import { VENUE_PLANS, VENUE_PLAN_NAMES } from '@/constants/subscriptions'

const URLS = {
    xhr: {
        fetch: {
            getPlans: '/api/profile/stripe/get-plans'
        }
    }
}

const venuePlans = ref([])
export function useVenuePlans() {
    const freeVenuePlan = VENUE_PLAN_NAMES.find((plan) => plan.name === 'Basic')
    const proVenuePlan = VENUE_PLAN_NAMES.find((plan) => plan.name === 'Pro')
    const _hedlynerPlans = ref([])

    ;(async () => {
        await _fetchHedlynerPlans()
        if (!venuePlans.value.length) _getSubscriptionPlans()
    })()

    async function _fetchHedlynerPlans() {
        const data = await api({
            method: 'get',
            url: URLS.xhr.fetch.getPlans
        })
        _hedlynerPlans.value = data.data
    }

    function _getSubscriptionPlans() {
        venuePlans.value = VENUE_PLANS.map((plan) => {
            let renderPlan = null

            switch (plan.name) {
                case freeVenuePlan.name:
                    renderPlan = {
                        ...plan,
                        selected: false,
                        render: false,
                        selectable: false
                    }
                    break
                case proVenuePlan.name:
                    renderPlan = {
                        ...plan,
                        selected: true,
                        render: true,
                        selectable: true
                    }
                    break
                default:
                    renderPlan = {
                        ...plan,
                        selected: false,
                        render: false,
                        selectable: true
                    }
            }

            renderPlan = {
                ...renderPlan,
                planTrials: {
                    month: _getPlanAttr('month', plan, 'trial_days'),
                    year: _getPlanAttr('year', plan, 'trial_days')
                },
                planPrices: {
                    month: _getPlanAttr('month', plan, 'price'),
                    year: _getPlanAttr('year', plan, 'price')
                },
                planProducts: {
                    month: _getPlanAttr('month', plan, 'product'),
                    year: _getPlanAttr('year', plan, 'product')
                },
                planIds: { month: _getPlanAttr('month', plan, 'id'), year: _getPlanAttr('year', plan, 'id') }
            }

            return renderPlan
        })
    }

    function _getPlanAttr(interval, plan, attr) {
        const hedlynerPlan = _getMatchingPlan(interval, plan)

        if (hedlynerPlan) {
            return hedlynerPlan[attr]
        } else {
            return null
        }
    }

    function _getMatchingPlan(interval, plan) {
        return _hedlynerPlans.value.find(
            (hedlynerPlan) => hedlynerPlan.name === plan.internalName && hedlynerPlan.interval === interval
        )
    }

    return {
        venuePlans,
        freeVenuePlan,
        proVenuePlan
    }
}
